<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            max="1000"
            min="0"
            :error="errors.bloodGlucose.length > 0"
            :error-messages="errors.bloodGlucose"
            v-model="form.bloodGlucose"
            :placeholder="$t('dashboard_new_evollu.measurement_types.blood_glucose_short')+' (mg/dl)'"
            :label="$t('dashboard_new_evollu.measurement_types.blood_glucose_short')+' (mg/dl)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <label class="form-label">{{$t('dashboard_new_evollu.measurement_types.fasting_short')}}</label>
        <multiselect
          v-model="fasting"
          trackBy="id"
          label="translation"
          :options="fastingOptions"
          :appendToBody="true"
          :multiple="false"
          :allowEmpty="false"
          placeholder="-----"
        />
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import Multiselect from 'vue-multiselect'

const BLOOD_GLUCOSE_TYPE_ID = 5
const FASTING_TYPE_ID = 58
export default {
  components: {
    Multiselect
  },
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      fastingOptions: [
        {
          id: 1,
          option: 1,
          translation: this.$t('yes')
        },
        {
          id: 2,
          option: 0,
          translation: this.$t('no')
        }
      ],
      fasting: null,
      form: {
        date: this.appointmentDates.start,
        bloodGlucose: null,
        fasting: null,
      },
      errors: {
        bloodGlucose: [],
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 4
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.bloodGlucose !== null && this.form.bloodGlucose !== '') &&
        (this.form.fasting !== null && this.form.fasting !== '')

        this.$emit('updateCanSubmit', canSubmit)
    },
  },
  watch: {
    "form.bloodGlucose": function(value) {
      if(value !== '' && (value < 1 || value > 1000)) {
        this.errors.bloodGlucose = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 1000})]
      }
      else {
        this.errors.bloodGlucose = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BLOOD_GLUCOSE_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BLOOD_GLUCOSE_TYPE_ID)
        elem.value = this.errors.bloodGlucose.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.bloodGlucose.length === 0 ? value : null,
          typeId: BLOOD_GLUCOSE_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "fasting": function(value) {
      if(value !== null) {
        this.form.fasting = value.option
        if(this.measurement.measurements.find(meas => meas.typeId === FASTING_TYPE_ID)) {
          let elem = this.measurement.measurements.find(meas => meas.typeId === FASTING_TYPE_ID)
          elem.value = value.option
        } else {
          this.measurement.measurements.push({
            value: value.option,
            typeId: FASTING_TYPE_ID
          })
        }
      }
      this.checkCanSubmit()
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
